import axios from 'axios';
import {API_ROOT} from '../constants';
export const userService = {
    create_driver,
    get_drivers,
    create_certificate,
    get_ucertificates,
    confirm_certificate,
    get_certificates_bd,
    get_drivers_bc,
    getucertificates_driver,
    delete_certificate,
};

function delete_certificate(userToken, driverId, certificate){
    let api = API_ROOT+'api/';
    let auth = 'Bearer ' + userToken;
    let type = 'application/json';
    let apiBaseUrl = api + 'deleteCertificate';
    return axios.delete(apiBaseUrl,{
        headers:
        { 'Authorization': auth, 'Content-Type': type },
        params:
        {
            'certificate': certificate,
            'driverId': driverId
        }  
    });

}
function create_driver(driver, userToken){
    let api = API_ROOT + 'api/';
    let auth = 'Bearer ' + userToken;
    let type = 'application/json';
    let apiBaseUrl = api + 'create_driver';
    return axios.get(apiBaseUrl, {
        headers:
            { 'Authorization': auth, 'Content-Type': type },
        params:
            {
                'name': driver.name,
                'surname': driver.surname,
                'licenceno':driver.licenceno,
                'licencetype': driver.licencetype,
                'licencedate': driver.licencedate,
                'licenceplace': driver.licenceplace,
            }, 
    });
    
}
function get_drivers(userToken){
    let api = API_ROOT +'api/';
    let auth = 'Bearer ' + userToken;
    let type = 'application/json';
    let apiBaseUrl = api + 'drivers';
    return axios.get(apiBaseUrl, {
        headers:
            { 'Authorization': auth, 'Content-Type': type },
    });
}
function get_ucertificates(userToken){
    let api = API_ROOT +'api/';
    let auth = 'Bearer ' + userToken;
    let type = 'application/json';
    let apiBaseUrl = api + 'unconfirmed_certificates';
    return axios.get(apiBaseUrl, {
        headers:
        { 'Authorization': auth, 'Content-Type': type},
    });
}
function confirm_certificate(driverId,certificate, userToken){

    let api = API_ROOT +'api/';
    let auth = 'Bearer ' + userToken;
    let type = 'application/json';
    let apiBaseUrl = api + `confirm_certificate?driverId=${driverId}&certificate=${certificate}`;
    let payload = {
     
    };
       
        
    return axios.put(apiBaseUrl, payload, {
        headers:
        { 'Authorization': auth, 'Content-Type': type }
    });
}
function getucertificates_driver(driverId, certificate, userToken){
    let api = API_ROOT +'api/';
    let auth = 'Bearer ' + userToken;
    let type = 'application/json';
    let apiBaseUrl = api + 'uCertificatesDriver';
    return axios.get(apiBaseUrl, {
        headers:
        { 'Authorization': auth, 'Content-Type': type },
        params:
        {
            'driverId': driverId,
            'certificate': certificate,
        },
    });

}

function get_certificates_bd(userToken, driverId){
    let api = API_ROOT +'api/';
    let auth = 'Bearer ' + userToken;
    let type = 'application/json';
    let apiBaseUrl = api + 'certificatesByDriver';
    return axios.get(apiBaseUrl, {
        headers:
        { 'Authorization': auth, 'Content-Type': type },
        params:
        {
            'driverId': driverId
        }
    });
}

function get_drivers_bc(userToken, certificate) {
    let api = API_ROOT +'api/';
    let auth = 'Bearer ' + userToken;
    let type = 'application/json';
    let apiBaseUrl = api + 'driversByCertificate';
    return axios.get(apiBaseUrl, {
        headers:
        { 'Authorization': auth, 'Content-Type': type },
        params:
        {
            'certificate': certificate
        }
    });
}

function create_certificate(certificate, userToken){ 

    let api = API_ROOT +'api/';
    let auth = 'Bearer ' + userToken;
    let type = 'application/json';
    let apiBaseUrl = api + 'create_certificate';

    var payload = {
        'DriverId': certificate.DriverId,
        'Certificate': certificate.Certificate,
        'VehiclePlate': certificate.VehiclePlate,
        'VehicleModel': certificate.VehicleModel,
        'VehicleBrand': certificate.VehicleBrand,
        'Distance': certificate.Distance,
        'Company': certificate.Company,
        'VehicleOwner': certificate.VehicleOwner,
        'Traffic': certificate.Traffic,
        'RoadType': certificate.RoadType,
        'Weather': certificate.Weather,
        'DriveCondition': certificate.DriveCondition,
        'Confirm': false,
        'EvaluationDate': certificate.EvaluationDate,
        'TotalPoint': certificate.TotalPoint,
        'CompCert': certificate.CompCert,
        'NofCerts': certificate.NofCerts,
        
        'Criteria': [
            {
                'CriteriaNo': 1,
                'Point': certificate.points['d1'],
                'Correct': '',
                'Confirm': ''},
            {
                'CriteriaNo': 2,
                'Point': certificate.points['d2'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 3,
                'Point': certificate.points['d3'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 4,
                'Point': certificate.points['d4'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 5,
                'Point': certificate.points['d5'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 6,
                'Point': certificate.points['d6'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 7,
                'Point': certificate.points['d7'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 8,
                'Point': certificate.points['d8'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 9,
                'Point': certificate.points['d9'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 10,
                'Point': certificate.points['d10'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 11,
                'Point': certificate.points['d11'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 12,
                'Point': certificate.points['d12'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 13,
                'Point': certificate.points['d13'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 14,
                'Point': certificate.points['d14'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 15,
                'Point': certificate.points['d15'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 16,
                'Point': certificate.points['d16'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 17,
                'Point': certificate.points['d17'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 18,
                'Point': certificate.points['d18'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 19,
                'Point': certificate.points['d19'],
                'Correct': '',
                'Confirm': ''
            },
            {
                'CriteriaNo': 20,
                'Point': certificate.points['d20'],
                'Correct': '',
                'Confirm': ''
            }
        ]       
    };
    
    return axios.post(apiBaseUrl, payload, {
        headers:
        { 'Authorization': auth, 'Content-Type': type }
    });

}


// WEBPACK FOOTER //
// ./src/services/userService.jsx